import styled from 'styled-components';

export const StyledCardSubTitle = styled.div`
  width: 100%;
  color: #2f2f35;
  font-family: Poppins, sans-serif;
  font-size: ${(props) => props.fontSize};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-overflow: ellipsis;
  text-align: left;
`;
